import TableCell from '@mui/material/TableCell';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';
import { entityDashboardRoutingSwitch } from 'features/navigation/routers/internal_routing';

const StyledTableCell = styled(TableCell)({
    paddingLeft: 5,
    paddingRight: 5,
});

function moversNameCellProvider(mover: any, clickEvent: (name: string) => void) {
    const targetUrl =
        mover && mover.entityIdentifier
            ? entityDashboardRoutingSwitch(
                  mover.entityIdentifier.entityType,
                  mover.entityIdentifier
              )
            : null;
    return (
        <StyledTableCell align="left">
            {mover.entityIdentifier && targetUrl ? (
                <Link
                    className="text-sky-600 hover:underline underline-offset-2"
                    to={targetUrl}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => clickEvent(mover.name)}
                >
                    {mover.entityIdentifier.entityName}
                </Link>
            ) : mover.name.startsWith('URL') ? (
                <Link
                    className="text-sky-600 hover:underline underline-offset-2"
                    to={mover.name.split('#')[2]}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => clickEvent(mover.name)}
                >
                    {mover.name.split('#')[1]}
                </Link>
            ) : (
                mover.name
            )}
        </StyledTableCell>
    );
}

export default moversNameCellProvider;
